import { getCookie } from 'common/cookies';
import EnvConfig from 'env.config';
import { defaultLanguage, saveLocale } from 'common/language/localeHelper';
import englishLanguageMessages from 'assets/lang/en.json';

import {
  AuthState,
  CONNECTION_STATUS,
  GET_ONLINE_CONFIG_REQUEST,
  GET_ONLINE_CONFIG_FAILURE,
  GET_ONLINE_CONFIG_SUCCESS,
  GET_LANGUAGES_REQUEST,
  GET_LANGUAGES_FAILURE,
  GET_LANGUAGES_SUCCESS,
  GET_LANGUAGE_REQUEST,
  GET_LANGUAGE_FAILURE,
  GET_LANGUAGE_SUCCESS,
  GET_JURISDICTIONS_REQUEST,
  GET_JURISDICTIONS_FAILURE,
  GET_JURISDICTIONS_SUCCESS,
  CLEAR_ONLINE_CONFIG_DEFAULT_FORM,
  CHANGE_LOCALE,
  CHANGE_LOCALE_MESSAGES,
  GET_DEFAULT_LANGUAGE_SUCCESS,
  EULA_ACCEPTED,
  SESSION_TIME_OUT,
  AUTH_STATE_REQUEST,
  AUTH_STATE_SUCCESS,
  GET_IGACOMBOS_SUCCESS,
  GET_IGACOMBOS_FAILURE,
  CLEAR_MODAL_UP_FRONT,
  GET_SPECIAL_RATE_PROVISIONS_SUCCESS,
  GET_SPECIAL_RATE_PROVISIONS_CLEAR,
  GET_OTHER_ARTICLES_SUCCESS,
  GET_OTHER_ARTICLES_CLEAR,
  GET_STOCK_MARKETS_SUCCESS,
  GET_STOCK_MARKETS_FAILURE,
  GET_LOBS_SUCCESS,
  GET_LOBS_FAILURE,
} from 'actions';

// eslint-disable-next-line default-param-last
function app(state = {
  isAuthenticated: false,
  isEulaAccepted: !!getCookie(EnvConfig.eulaCookieName),
  locale: defaultLanguage.key,
  languages: [defaultLanguage],
  messages: { 'loading.message': '...' },
  englishMessages: englishLanguageMessages,
  isFetching: false,
  onlineConfig: null,
  shortDictionaryLoaded: false,
  fullDictionaryLoaded: false,
  jurisdictionsLoading: false,
  staticData: {
    jurisdictions: null,
    usTaxTreatyCountries: null,
    annexIICountries: null,
    igaSubClassificationsCombos: null,
    stockMarkets: [],
    lobs: []
  },
  bypassEula: false,
  isOnline: true,
  retries: 0,
  connectionInfo: null,
  authState: AuthState.Unknown,
  customerData: null,
  key: null,
  defaultFormType: null,
  defaultFormUrl: null
}, action) {
  switch (action.type) {
    case CONNECTION_STATUS:
      return {
        ...state,
        connectionInfo: action.connectionInfo,
        isOnline: action.isOnline,
        retries: action.retries
      };
    case GET_ONLINE_CONFIG_REQUEST:
      return {
        ...state
      };
    case GET_ONLINE_CONFIG_SUCCESS:
      return {
        ...state,
        onlineConfig: action.onlineConfig,
        customerData: action.customerData,
        key: action.key,
        isAuthenticated: true
      };
    case GET_ONLINE_CONFIG_FAILURE:
      return {
        ...state,
        isFetching: false,
        bypassEula: true
      };
    case GET_LANGUAGES_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case GET_LANGUAGES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        languages: action.languages,
      };
    case GET_LANGUAGES_FAILURE:
      return {
        ...state,
        isFetching: false
      };
    case GET_LANGUAGE_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case GET_LANGUAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        locale: action.locale,
        messages: action.messages,
        englishMessages: action.locale === 'en' ? action.messages : state.englishMessages,
        fullDictionaryLoaded: true
      };
    case GET_LANGUAGE_FAILURE:
      return {
        ...state,
        isFetching: false
      };
    case GET_JURISDICTIONS_REQUEST:
      return {
        ...state,
        jurisdictionsLoading: true
      };
    case GET_JURISDICTIONS_SUCCESS:
      return {
        ...state,
        jurisdictionsLoading: false,
        staticData: {
          ...state.staticData,
          jurisdictions: action.jurisdictions,
          usTaxTreatyCountries: action.usTaxTreatyCountries,
          annexIICountries: action.annexIICountries
        }
      };
    case GET_JURISDICTIONS_FAILURE:
      return {
        ...state,
        jurisdictionsLoading: false
      };
    case CHANGE_LOCALE:
      if (action?.locale) {
        saveLocale(action.locale);

        return {
          ...state,
          locale: action.locale,
        };
      }
      return { ...state };
    case CHANGE_LOCALE_MESSAGES:
      if (state.fullDictionaryLoaded) {
        return {
          ...state,
          shortDictionaryLoaded: true,
        };
      }
      return {
        ...state,
        shortDictionaryLoaded: true,
        messages: action.messages,
      };
    case GET_DEFAULT_LANGUAGE_SUCCESS:
      return {
        ...state,
        englishMessages: action.messages
      };
    case EULA_ACCEPTED:
      return {
        ...state,
        isEulaAccepted: true
      };
    case CLEAR_ONLINE_CONFIG_DEFAULT_FORM:
      return {
        ...state,
        onlineConfig: {
          ...state.onlineConfig,
          defaultFormType: null,
          defaultFormUrl: action.defaultFormUrl ?? null
        }
      };
    case SESSION_TIME_OUT:
      return {
        ...state,
        isAuthenticated: false
      };
    case AUTH_STATE_REQUEST:
    case AUTH_STATE_SUCCESS:
      return {
        ...state,
        authState: action.authState
      };
    case GET_IGACOMBOS_SUCCESS:
      return {
        ...state,
        staticData: {
          ...state.staticData,
          igaSubClassificationsCombos: action.igaSubClassificationsCombos
        }
      };
    case GET_IGACOMBOS_FAILURE:
      return {
        ...state,
        staticData: {
          ...state.staticData,
          igaSubClassificationsCombos: null
        }
      };
    case GET_LOBS_SUCCESS:
      return {
        ...state,
        staticData: {
          ...state.staticData,
          lobs: action.lobs
        }
      };
    case GET_LOBS_FAILURE:
      return {
        ...state,
        staticData: {
          ...state.staticData,
          lobs: null
        }
      };
    case CLEAR_MODAL_UP_FRONT:
      return {
        ...state,
        onlineConfig: {
          ...state.onlineConfig,
          showFormInstructionsUpFront: false,
        }
      };
    case GET_SPECIAL_RATE_PROVISIONS_SUCCESS:
      return {
        ...state,
        specialRateProvisions: action.specialRateProvisions
      };
    case GET_SPECIAL_RATE_PROVISIONS_CLEAR:
      return {
        ...state,
        specialRateProvisions: null
      };
    case GET_OTHER_ARTICLES_SUCCESS:
      return {
        ...state,
        otherArticles: action.otherArticles
      };
    case GET_OTHER_ARTICLES_CLEAR:
      return {
        ...state,
        otherArticles: null
      };
    case GET_STOCK_MARKETS_SUCCESS:
      return {
        ...state,
        staticData: {
          ...state.staticData,
          stockMarkets: action.stockMarkets,
        },
      };
    case GET_STOCK_MARKETS_FAILURE:
      return {
        ...state,
        staticData: {
          ...state.staticData,
          stockMarkets: [],
        },
      };
    default:
      return state;
  }
}

export default app;
